import React from 'react'
import { Box, Typography, Pagination } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import { paginateSearch } from '../../../redux/actions/searchAction'
import { useSearchTokens } from '../searchDesignTokens'

export const SearchPagination = ({
  containerStyle = {},
  paginationStyle = {},
  showTotalResults = true
}) => {
  const { t } = useTranslation()
  const dk = useSearchTokens()
  const dispatch = useDispatch()

  const currentPage = useSelector(state => state.search.currentPage)
  const totalPages = useSelector(state => state.search.totalPages)
  const filteredCount = useSelector(state => state.search.filteredCount)
  const totalResultCount = useSelector(state => state.search.totalResultCount)
  const currentSearchId = useSelector(state => state.search.currentSearchId)
  const searchFilters = useSelector(state => state.search.searchFilters)
  const pageSize = useSelector(state => state.search.pageSize)

  const startItem = filteredCount > 0 ? (currentPage - 1) * pageSize + 1 : 0
  const endItem = Math.min(currentPage * pageSize, filteredCount)

  const handlePageChange = (event, newPage) => {
    if (currentSearchId) {
      dispatch(paginateSearch(currentSearchId, searchFilters, newPage))
      const resultsContainer = document.querySelector('[data-results-scroll]')
      if (resultsContainer) {
        resultsContainer.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }

  if (filteredCount === 0) return null

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 16px',
        borderRadius: '8px',
        backgroundColor: dk.elevated,
        ...containerStyle
      }}
    >
      {showTotalResults && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FormatListNumberedIcon sx={{ color: dk.text3, fontSize: '0.9rem', mr: 1 }} />
          <Typography
            variant='body2'
            sx={{
              color: dk.text2,
              flexShrink: 0,
              fontSize: '0.85rem',
              fontWeight: 500
            }}
          >
            {filteredCount === 0
              ? t('no_results')
              : `${filteredCount} ${t('results_count')}${
                  filteredCount > 0 ? ` (${startItem}-${endItem})` : ''
                }`}
          </Typography>
        </Box>
      )}

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          size='small'
          showFirstButton
          showLastButton
          sx={{
            '.MuiPagination-ul': {
              justifyContent: 'flex-end'
            },
            '.MuiPaginationItem-root': {
              color: dk.text2,
              fontWeight: 500,
              borderRadius: '4px',
              minWidth: '32px',
              height: '32px',
              '&:hover': {
                backgroundColor: dk.hover,
              },
            },
            '.MuiPaginationItem-root.Mui-selected': {
              backgroundColor: dk.gold,
              color: '#000',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: dk.gold,
                opacity: 0.9,
              }
            },
            ...paginationStyle
          }}
        />
      )}
    </Box>
  )
}

export default SearchPagination
